import { render, staticRenderFns } from "./show_item.vue?vue&type=template&id=66720846&scoped=true"
import script from "./show_item.vue?vue&type=script&lang=ts"
export * from "./show_item.vue?vue&type=script&lang=ts"
import style0 from "./show_item.vue?vue&type=style&index=0&id=66720846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66720846",
  null
  
)

export default component.exports